import { Copy, Code2 } from 'lucide-react';
import { Button, Dialog, DialogContent, DialogHeader, DialogTitle } from '@shigo-ui/ui';

import { readShigoAppConfig } from '../../../../../lib/config';
import { dashboardT } from '../../../../../lib/messages';
import type { Placement } from '../../model';
import { createPlacementUnitTag } from '../../unitTag';
import { copyToClipboard } from '../../../../../lib/clipboard';

export function UnitTagPreviewDialog({
  placement,
  onOpenChange,
}: {
  placement: Placement | null;
  onOpenChange: (open: boolean) => void;
}) {
  const config = readShigoAppConfig();
  const tag = createPlacementUnitTag(placement?.secondaryId, config.cdnUrl);
  return (
    <Dialog open={Boolean(placement)} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Code2 className="h-5 w-5" aria-hidden="true" />
            {dashboardT('placements.unitTag')}
          </DialogTitle>
        </DialogHeader>
        <pre className="border-input bg-muted/30 max-h-[55vh] overflow-auto rounded-md border p-4 text-xs whitespace-pre-wrap">
          {tag}
        </pre>
        <div className="flex justify-end">
          <Button
            type="button"
            disabled={!tag}
            onClick={() => {
              void copyToClipboard(tag, {
                successMessage: dashboardT('placements.unitTagCopied'),
                errorMessage: dashboardT('placements.copyError'),
              });
            }}
          >
            <Copy className="h-4 w-4" aria-hidden="true" />
            {dashboardT('placements.copy')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
